<template>
  <v-card autofocus @keydown.esc="cancel">
    <v-toolbar :color="event.color" dense dark elevation="1">
      <v-app-bar-nav-icon>
        <v-icon>mdi-calendar</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer />
      <v-toolbar-title>
        イベント
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="cancel" v-on="on">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>閉じる</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <validate-observer ref="observer">
        <v-skeleton-loader
          :loading="eventLoading"
          type="list-item-avatar"
          transition="fade-transition"
          ><v-row>
            <v-col cols="1"><v-icon>mdi-camera</v-icon></v-col>
            <v-col cols="11">
              <validate-provider
                v-slot="{ errors }"
                ref="groupValidate"
                rules="selection"
              >
                <treeselect
                  class="event-treeSelect"
                  v-model="selectedStructure"
                  valueFormat="object"
                  :multiple="true"
                  :options="deviceStructure"
                  :z-index="1500"
                  :show-count="true"
                  placeholder="出力先を選択してください。"
                  :noResultsText="errors[0]"
                  required
                >
                  <div slot="value-label" slot-scope="{ node }">
                    <span
                      ><v-icon color="secondary" class="mr-2">
                        {{ getDeviceIcon(node.raw.type) }}</v-icon
                      ></span
                    >{{ node.raw.label }}
                  </div>
                  <label
                    slot="option-label"
                    slot-scope="{
                      node,
                      shouldShowCount,
                      count,
                      labelClassName,
                      countClassName
                    }"
                    :class="labelClassName"
                  >
                    <v-icon small class="mr-2">{{
                      getDeviceIcon(node.raw.type)
                    }}</v-icon
                    >: {{ node.label }}
                    <span v-if="shouldShowCount" :class="countClassName"
                      >({{ count }})</span
                    >
                  </label>
                </treeselect>
              </validate-provider>
              <span v-if="selecteionInfo" class="selInfo">{{
                selecteionInfo
              }}</span>
            </v-col>
          </v-row>
        </v-skeleton-loader>

        <v-skeleton-loader
          :loading="eventLoading"
          type="list-item-avatar"
          transition="fade-transition"
          ><v-row>
            <v-col cols="1"><v-icon>mdi-chart-bubble</v-icon></v-col>
            <v-col cols="11">
              <validate-provider
                v-slot="{ errors }"
                name="playlist"
                rules="selection"
              >
                <v-select
                  v-model="event.playlist"
                  :items="playlistSelections"
                  item-text="name"
                  item-value="uid"
                  :error-messages="errors"
                  label="プレイリスト"
                  dense
                />
              </validate-provider>
            </v-col>
          </v-row>
        </v-skeleton-loader>

        <v-row dense class="mt-6">
          <v-col cols="12">
            <validate-provider
              ref="datesValidator"
              rules="required"
              v-slot="{ errors }"
            >
              <p class="filterheader-label text-caption pb-1">
                <v-icon small class="pr-2">mdi-calendar-clock</v-icon
                ><span>開始終了期間</span>
              </p>
              <vue-ctk-date-time-picker
                id="date-time-input"
                v-model="selectedDates"
                :error="errors.length > 0"
                :label="errors[0]"
                format="YYYY-MM-DD"
                formatted="ll"
                locale="ja-jp"
                range
                only-date
                no-header
                no-label
                class="event-date-picker"
              />
            </validate-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-icon small class="pr-2">mdi-clock-time-three-outline</v-icon
            ><span style="font-size: 12px;">範囲時間</span>
          </v-col>
        </v-row>
        <v-row class="pl-3">
          <v-col cols="auto" md="6" sm="6">
            <p class="filterheader-label text-caption pb-1">
              <v-icon small class="pr-2">mdi-hours-24</v-icon
              ><span>24時間稼働</span>
            </p>
            <v-switch
              v-model="event.nonstop"
              :label="`停止時間なしで、一日中稼働する`"
            ></v-switch>
          </v-col>
          <v-col cols="auto" md="6" sm="6">
            <!-- empty column to make arranged grid design -->
          </v-col>
          <v-col class="overlay-target" cols="auto" md="6" sm="6">
            <validate-provider
              ref="timeFromValidator"
              rules="required"
              v-slot="{ errors }"
            >
              <p class="filterheader-label text-caption pb-1">
                <v-icon small class="pr-2">mdi-clock-start</v-icon
                ><span>開始時間</span>
              </p>
              <vue-ctk-date-time-picker
                id="start-time-input"
                v-model="event.startTime"
                :error="errors.length > 0"
                :label="errors[0]"
                :minute-interval="5"
                format="LT"
                formatted="LT"
                locale="ja-jp"
                only-time
                no-header
                no-label
                class="event-date-picker"
              />
            </validate-provider>
            <div v-if="event.nonstop" class="overlay"></div>
          </v-col>
          <v-col class="overlay-target" auto md="6" sm="6">
            <validate-provider
              ref="timeToValidator"
              rules="required"
              v-slot="{ errors }"
            >
              <p class="filterheader-label text-caption pb-1">
                <v-icon small class="pr-2">mdi-clock-end</v-icon
                ><span>終了時間</span>
              </p>
              <vue-ctk-date-time-picker
                id="end-time-input"
                v-model="event.endTime"
                :error="errors.length > 0"
                :label="errors[0]"
                :minute-interval="5"
                format="LT"
                formatted="LT"
                locale="ja-jp"
                only-time
                no-header
                no-label
                class="event-date-picker"
              />
            </validate-provider>
            <div v-if="event.nonstop" class="overlay"></div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-item-group v-model="event.color">
              <v-icon left>mdi-palette-outline</v-icon>
              <v-item
                v-for="color in getEventColors()"
                :key="color"
                :value="color"
                style="cursor: pointer;"
              >
                <template v-slot="{ active, toggle }">
                  <v-avatar
                    :class="active && 'v-settings__item--active'"
                    :color="color"
                    class="v-settings__item mx-1"
                    size="20"
                    @click="toggle"
                  />
                </template>
              </v-item>
            </v-item-group>
          </v-col>
          <v-col cols="6">
            <validate-provider
              v-slot="{ errors }"
              name="repeat"
              rules="selection"
            >
              <v-select
                v-model="event.pattern"
                :items="getEventRepeatPatterns()"
                :error-messages="errors"
                label="繰り返し"
              />
            </validate-provider>
          </v-col>
        </v-row>
      </validate-observer>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn v-if="editMode" color="red" outlined @click="removeEvent">
        削除
      </v-btn>
      <v-btn color="warning" outlined @click="cancel">
        キャンセル
      </v-btn>
      <v-btn color="success" outlined @click="saveEvent" :disabled="!valid">
        保存
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
    </v-card-actions>
    <!--validation device and date duplicate-->
    <v-dialog v-model="validateDialog" max-width="400">
      <v-card class="ma-0">
        <v-card-title class="text-h3">
          設定された日程とデバイスが,
          重複するスケジュールが既にあります。</v-card-title
        >
        <v-card-text>
          デバイス、ユニット、グループの順に優先的にプレイリストが再生されます。
        </v-card-text>
        <v-card-actions>
          <v-btn color="green darken-1" text @click="validateDialog = false"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { Pick } from '@/protocol'
import { mapActions, mapGetters } from 'vuex'
import { ValidateObserver, ValidateProvider } from '@/plugins/validators'
import { deviceFunctionsMixin, eventFunctionsMixin } from '@/plugins/mixins'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { concat } from 'lodash/core'
import { uniq, difference } from 'lodash/array'
import { functions } from '@/config/firebase'

export default {
  name: 'ScheduleEventCard',
  mixins: [eventFunctionsMixin, deviceFunctionsMixin],
  props: {
    event: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ValidateProvider,
    ValidateObserver,
    VueCtkDateTimePicker,
    Treeselect
  },
  data() {
    return {
      eventLoading: true,
      valid: false,
      datePickerOpen: false,
      validateDialog: false,
      selectedDates: { start: this.event.startDate, end: this.event.endDate },
      selectedStructure: [],
      playlistSelections: [],

      selecteionInfo: ''
    }
  },
  computed: {
    ...mapGetters({
      devices: 'devices/getDevices',
      units: 'devices/units/getUnits',
      groups: 'devices/groups/getGroups',
      playlists: 'playlists/getPlaylists'
    }),
    eventDraft() {
      let playlist = this.event.playlist

      const draft = {
        playlist,
        devices: this.getStructureDevices(this.selectedStructure),
        startDate: this.selectedDates ? this.selectedDates.start : null,
        endDate: this.selectedDates ? this.selectedDates.end : null,
        startTime: this.event.startTime,
        endTime: this.event.endTime,
        pattern: this.event.pattern,
        color: this.event.color,
        nonstop: this.event.nonstop ? this.event.nonstop : false
      }

      if (this.event.nonstop) {
        draft.startTime = '00:00'
        draft.endTime = '23:59'
      }

      return draft
    },
    deviceStructure() {
      const devices = this.devices.map(d => {
        return { id: d.id, label: d.name, type: 'device' }
      })
      const units = this.units.map(u => {
        return { id: u.id, label: u.name, type: 'unit' }
      })
      const groups = this.groups.map(g => {
        return { id: g.id, label: g.name, type: 'group' }
      })
      // make group => unit => structure model
      return concat(groups, units, devices)
    }
  },
  methods: {
    ...mapActions({
      showSnack: 'snackbar/showSnack',

      bindPlaylistsRef: 'playlists/bindRef',
      bindDevicesRef: 'devices/bindRef',
      bindDeviceGroupsRef: 'devices/groups/bindRef',
      bindDeviceUnitsRef: 'devices/units/bindRef'
    }),
    cancel() {
      this.$emit('cancel')
      this.selectedStructure = []
    },
    saveEvent() {
      this.$refs.observer.validate().then(valid => {
        if (valid) {
          this.$emit('save', this.eventDraft)
          this.selectedStructure = []
        }
      })

      const updateDevicesConfig = functions.httpsCallable(
        'device-UpdateDevicesConfig'
      )
      updateDevicesConfig({ deviceIds: this.eventDraft.devices })
        .then(result => {
          if (result.data.success) {
            this.showSnack({
              message: 'デバイス設定の更新を保存しました',
              color: 'success'
            })
          } else {
            this.showSnack({
              message: `デバイス設定更新の保存に失敗しました: ${result.data.message}`,
              color: 'error'
            })
          }
        })
        .catch(error => {
          this.showSnack({
            message: `デバイス設定更新の保存に失敗しました: ${error}`,
            color: 'error'
          })
        })
    },
    removeEvent() {
      this.$emit('remove', this.eventDraft)
    },
    getDeviceIcon(type) {
      return this.getDeviceType().find(d => d.type === type).icon
    },
    getStructureDevices(structure) {
      // todo: fetch these from the structure somehow, without string filtering
      const groupIds = structure.filter(s => s.type === 'group').map(e => e.id)
      const unitIds = structure.filter(s => s.type === 'unit').map(e => e.id)

      const groupDevices = this.devices
        .filter(d => d.groups.some(g => groupIds.includes(g)))
        .map(e => e.id)
      const unitDevices = this.devices
        .filter(d => d.units.some(g => unitIds.includes(g)))
        .map(e => e.id)
      const devices = structure.filter(s => s.type === 'device').map(e => e.id)

      return uniq(concat(devices, unitDevices, groupDevices))
    },
    fixPriority(selection) {
      const groupIds = selection.filter(s => s.type === 'group').map(e => e.id)
      const unitIds = selection.filter(s => s.type === 'unit').map(e => e.id)
      let groupDevices = this.devices
        .filter(d => d.groups.some(g => groupIds.includes(g)))
        .map(e => e.id)
      let unitDevices = this.devices
        .filter(d => d.units.some(g => unitIds.includes(g)))
        .map(e => e.id)
      const devices = selection.filter(s => s.type === 'device').map(e => e.id)

      groupDevices = difference(groupDevices, devices)
      groupDevices = difference(groupDevices, unitDevices)
      unitDevices = difference(unitDevices, devices)
      // device , unit , group の順番で優先順位をつける
      return {
        devices: devices,
        units: unitDevices,
        group: groupDevices
      }
    },
    addExistingDevices() {
      // if event already had devices selected, merge them into the draft
      if (this.event?.devices?.length > 0) {
        this.selectedStructure = this.devices
          .filter(f => this.event.devices.includes(f.id))
          .map(d => {
            return { id: d.id, label: d.name, type: 'device' }
          })
      }
    }
  },
  watch: {
    event() {
      this.addExistingDevices()
    },
    eventDraft() {
      const dates = this.$refs.datesValidator.validate(
        this.eventDraft.startDate && this.eventDraft.endDate
      )
      const startTime = this.$refs.timeFromValidator.validate(
        this.eventDraft.startTime
      )
      const endTime = this.$refs.timeToValidator.validate(
        this.eventDraft.endTime
      )

      Promise.all([dates, startTime, endTime]).then(results => {
        this.valid =
          results.every(r => r.valid === true) &&
          this.selectedStructure.length > 0
      })
    },
    selectedStructure: function(newSelected, oldSelected) {
      if (
        newSelected &&
        oldSelected &&
        newSelected.length !== oldSelected.length
      ) {
        if (newSelected.length > 0) {
          const selectedUnitIds = []
          const selectedGroupIds = []
          const selectedDeviceIds = []
          for (const selected of newSelected) {
            switch (selected.type) {
              case 'unit':
                selectedUnitIds.push(selected.id)
                break
              case 'group':
                selectedGroupIds.push(selected.id)
                break
              case 'device':
                selectedDeviceIds.push(selected.id)
                break
            }
          }

          if (selectedUnitIds.length > 0) {
            const unitDeviceIds = this.devices
              .filter(d => d.units.some(g => selectedUnitIds.includes(g)))
              .map(e => e.id)
            unitDeviceIds?.forEach(u => selectedDeviceIds.push(u))
          }

          if (selectedGroupIds.length > 0) {
            const groupDeviceIds = this.devices
              .filter(d => d.groups.some(g => selectedGroupIds.includes(g)))
              .map(e => e.id)
            groupDeviceIds?.forEach(u => selectedDeviceIds.push(u))
          }

          const displayModeDevices = []
          // Collect not display mode devices out of selected devices.
          for (const selectedDeviceId of selectedDeviceIds) {
            const device = this.devices.find(d => d.id === selectedDeviceId)
            if (device && device.mode !== Pick.Device.Config.Mode.MODE_PLAYER) {
              displayModeDevices.push(device)
            }
          }

          // Show info if not display mode device exists.
          if (displayModeDevices.length > 0) {
            let deviceNames = displayModeDevices[0].name
            if (displayModeDevices.length > 0) {
              deviceNames = displayModeDevices.map(d => d.name).join(', ')
            }
            this.selecteionInfo = `${deviceNames} はディスプレイモードではありません\nスケジュール設定後にモードを変更する必要があります`
            return
          }
        }
      }

      // Set empty if there are no selected divices which are not diaplay mode.
      this.selecteionInfo = ''
    }
  },
  mounted() {
    this.addExistingDevices()
  },
  created() {
    const playlists = this.bindPlaylistsRef()
    const devices = this.bindDevicesRef()
    const deviceGroups = this.bindDeviceGroupsRef()
    const deviceUnits = this.bindDeviceUnitsRef()

    Promise.all([playlists, devices, deviceGroups, deviceUnits]).then(() => {
      this.eventLoading = false
      this.addExistingDevices()

      this.playlistSelections = []
      for (const playlist of this.playlists) {
        this.playlistSelections.push(playlist)
      }
    })
  }
}
</script>

<style lang="sass">
.v-settings
  &__item
    border-width: 3px
    border-style: solid
    border-color: transparent !important

    &--active
      border-color: #BCEDFF !important

.event-date-picker
  overflow: visible

.event-treeSelect
  .vue-treeselect__control
    border-radius: 0
    border: 0
    border-bottom: 1px solid #ddd

.vue-treeselect__control-arrow
  padding-left: 1px
  width: 8px
  color: #757575

.selInfo
  white-space: pre-wrap
  word-wrap: break-word
  font-size: 12px
  line-height: 0.7
  color: cornflowerblue

.overlay-target
  position: relative

.overlay
  position: absolute
  background: gray
  width: 100%
  height: 100%
  left: 0
  top: 0
  opacity: 0.3
</style>
